/* Pod Nutrition — "Buy 2 Get 1 Free" floating-cart messaging + top ticker.
   Self-contained: watches the cart drawer's item list for changes (however
   they happen — pod.js's own AJAX cart, a future change, anything) and
   independently reads /cart.js so it never depends on pod.js internals. */
(function () {
  'use strict';

  var msgEl, popupEl, itemsList;
  var lastCount = null;
  var rendersSeen = 0;
  var fetchTimer = null;
  var popupTimer = null;

  function showPopup() {
    if (!popupEl) return;
    clearTimeout(popupTimer);
    popupEl.classList.remove('dbogo-popup--hide');
    popupEl.hidden = false;
    void popupEl.offsetWidth; /* restart the enter transition every time */
    popupEl.classList.add('dbogo-popup--show');
    popupTimer = setTimeout(function () {
      popupEl.classList.remove('dbogo-popup--show');
      popupEl.classList.add('dbogo-popup--hide');
      setTimeout(function () {
        popupEl.hidden = true;
        popupEl.classList.remove('dbogo-popup--hide');
      }, 350);
    }, 2600);
  }

  function updateUI(n) {
    rendersSeen++;
    if (msgEl) {
      if (n === 1) {
        msgEl.hidden = false;
        msgEl.classList.remove('dbogo--final');
        msgEl.innerHTML = 'Add <b>1 more</b> product to get your <b>3rd FREE</b>!';
      } else if (n === 2) {
        msgEl.hidden = false;
        msgEl.classList.add('dbogo--final');
        msgEl.innerHTML = 'Add <b>1 more</b> — your <b>3rd product is FREE</b>!';
      } else {
        msgEl.hidden = true;
        msgEl.classList.remove('dbogo--final');
      }
    }
    if (n > 0 && n % 3 === 0 && lastCount !== n && rendersSeen > 1) {
      showPopup();
    }
    lastCount = n;
  }

  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateUI(cart.item_count || 0); })
      .catch(function () {});
  }

  function scheduleRefresh() {
    clearTimeout(fetchTimer);
    fetchTimer = setTimeout(refresh, 150);
  }

  /* Rotating top ticker — alternates the prepaid-discount and BOGO lines in
     the single compact slot at the top of the drawer. */
  function initTicker() {
    var msgs = document.querySelectorAll('#cartTicker .dtick-msg');
    if (!msgs.length) return;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove('dtick-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('dtick-active');
    }, 3200);
  }

  function boot() {
    msgEl = document.getElementById('cartBogoMsg');
    popupEl = document.getElementById('cartBogoPopup');
    itemsList = document.getElementById('cartItemsList');
    initTicker();
    if (!itemsList || !msgEl) return;
    refresh();
    var observer = new MutationObserver(scheduleRefresh);
    observer.observe(itemsList, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
